module.exports = __webpack_public_path__ + "79cb5013a47cb205253ab1b5f7c2f1f5.wav";